import { render } from "./DashboardBlockWizard.vue?vue&type=template&id=1a2af7cf&scoped=true"
import script from "./DashboardBlockWizard.vue?vue&type=script&lang=js"
export * from "./DashboardBlockWizard.vue?vue&type=script&lang=js"

import "./DashboardBlockWizard.vue?vue&type=style&index=0&id=1a2af7cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2af7cf"]])

export default __exports__